import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { UserPermissionsService } from '../services/user-permissions.service';

@Injectable({ providedIn: 'root' })
export class FitnessGuard implements CanActivate {
  constructor(
    private readonly userPermissions: UserPermissionsService,
    private readonly router: Router
  ) {}

  canActivate(): Observable<boolean> {
    return this.userPermissions.load().pipe(
      map(() => {
        if (this.userPermissions.hasPermission('user:fitness')) {
          return true;
        }
        void this.router.navigate(['/']);
        return false;
      })
    );
  }
}
